import React, { useState, useEffect } from 'react';
import CurrencyInput from 'react-currency-input-field';

export default function RadioQuestion({ questionData, setFormData, loading }) {
  const {
    question,
    answerChoices,
    inputName,
    subInputName,
    currentAnswer,
    currentSubAnswer
  } = questionData;
  const [selectedValue, setSelectedValue] = useState('');
  const [subInput, setSubInput] = useState({
    value: '',
    name: ''
  });

  const handleInputChange = (event) => setSelectedValue(event.target.value);

  const handleSubInputChange = (value, subInputName) =>
    setSubInput({ value: value, name: subInputName });

  // modify data for clean return to parent component
  const formatResponseData = (selectedValue, subInput) => {
    const formattedResponse = {
      [inputName]: '',
      [subInput.name]: ''
    };

    formattedResponse[subInput.name] =
      selectedValue === 'no' || selectedValue === 'unknown'
        ? ''
        : subInput.value;

    formattedResponse[inputName] = selectedValue;

    return formattedResponse;
  };

  // update parent components state
  useEffect(() => {
    const response = formatResponseData(selectedValue, subInput);

    setFormData((state) => {
      return {
        ...state,
        ...response
      };
    });
  }, [selectedValue, subInput]);

  // set previous/fetched respondent survey answer
  useEffect(() => {
    setSelectedValue(currentAnswer);
    setSubInput((state) => {
      return { ...state, value: currentSubAnswer };
    });
  }, [currentAnswer, currentSubAnswer]);

  return (
    <div className="section__gray-body">
      <div className="mc-question">
        <h5>{question}</h5>
        <div className="mc-answer__list">
          {answerChoices.map((answerChoice, index) => (
            <div
              key={index}
              className={`mc-answer__item ${
                loading ? 'mc-answer__item--skeleton' : null
              }`}
            >
              <input
                type="radio"
                id={`${question}-${answerChoice}-${index}`}
                name={inputName}
                value={answerChoice.value}
                onChange={(event) => handleInputChange(event)}
                checked={answerChoice.value === selectedValue ? true : false}
              />
              <div className="mc-answer__choice">
                <label htmlFor={`${question}-${answerChoice}-${index}`}>
                  {answerChoice.label}
                </label>
                {answerChoice.subquestion &&
                  selectedValue === answerChoice.value && (
                    <div
                      className={`mc-answer__detail ${
                        currentSubAnswer === '' ? 'form__field--error' : ''
                      }`}
                    >
                      <label>
                        {answerChoice.subquestion}
                        {answerChoice.inlineDirection && (
                          <span> {answerChoice.inlineDirection}</span>
                        )}
                      </label>
                      {answerChoice.subDetail && (
                        <div className="mc-answer__sub-detail">
                          Please indicate the total amount of propane storage in
                          gallons.
                        </div>
                      )}
                      {answerChoice.unit ? (
                        <div className="u--display-flex u--align-items-center">
                          <CurrencyInput
                            className="form__input form__input--lg form__input--short"
                            type="text"
                            name={subInputName}
                            value={currentSubAnswer ? currentSubAnswer : ''}
                            onValueChange={(value, name) =>
                              handleSubInputChange(value, name)
                            }
                            allowNegativeValue={false}
                          />
                          <span className="u--margin-left-20">gallons</span>
                        </div>
                      ) : (
                        <input
                          className="form__input form__input--lg"
                          type="text"
                          name={subInputName}
                          value={currentSubAnswer ? currentSubAnswer : ''}
                          onChange={(event) =>
                            handleSubInputChange(
                              event.target.value,
                              subInputName
                            )
                          }
                        />
                      )}
                    </div>
                  )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
